import { combineReducers } from 'redux';

import { StoreState } from '../interfaces';
import { homographyReducer } from './homography/homographyReducer';
import { HomographyState } from './homography/homographyState';
import { storeReducer } from './store/storeReducer';

export interface AppState {
  store: StoreState;
  homography: HomographyState;
}

export const rootReducer = combineReducers<AppState>({
  store: storeReducer,
  homography: homographyReducer,
});
